import { PlusIcon } from '@heroicons/react/16/solid'
import PropTypes from 'prop-types'
import SampleBadge from '../../../../components/sample-data/sample-badge'
import Button from '../../../../components/tailwind/Button'
import { Heading } from '../../../../components/ui/Heading'
import { truncateCareerID } from '../../../../helpers'
import TalentBadge from './TalentBadge'

/**
 * Molecule Component: TalentSuggestionCard
 * Displays a suggested talent with add functionality
 */
const TalentSuggestionCard = ({ talent, onAdd, className = '', isAdded }) => {
  const displayName = talent.name || talent.email || String(talent.id)
  const truncatedName =
    displayName.length > 40 ? displayName.slice(0, 37) + '...' : displayName

  return (
    <div className={`flex h-[4.5rem] items-center ${className}`}>
      <div className='flex w-full items-center justify-between'>
        <div className='flex items-center space-x-3'>
          <TalentBadge name={displayName} />
          <div>
            <div className='flex items-center space-x-1'>
              <Heading level={5} title={displayName}>
                {truncatedName}
              </Heading>
              {talent.isDemo && <SampleBadge kind='talent' />}
            </div>
            {displayName !== String(talent.id) && (
              <div className='text-sm text-gray-500' title={String(talent.id)}>
                {truncateCareerID(String(talent.id))}
              </div>
            )}
          </div>
        </div>
        <div className='flex items-center space-x-2'>
          <Button.SecondaryLG
            text={isAdded ? 'Hinzugefügt' : 'Hinzufügen'}
            icon={
              !isAdded && (
                <PlusIcon className='size-4 text-buttonSecondaryBlue' />
              )
            }
            onClick={() => !isAdded && onAdd(talent)}
            disabled={Boolean(isAdded)}
          />
        </div>
      </div>
    </div>
  )
}

TalentSuggestionCard.propTypes = {
  talent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    email: PropTypes.string,
    isDemo: PropTypes.bool
  }).isRequired,
  onAdd: PropTypes.func.isRequired,
  className: PropTypes.string,
  isAdded: PropTypes.bool
}

export default TalentSuggestionCard
